export default function Marquee() {
  const words = ["Master Dog Trainer", "The Wolfkeeper", "Consciousness of Abundance", "TAS555 Event Spaces", "Digital Beast AI", "Founder · Author · Speaker", "Chicago · Nairobi · The World"];
  const line = (
    <div className="flex items-center gap-16 pr-16">
      {words.map((w, i) => (
        <span key={i} className="flex items-center gap-16">
          <span className="font-display italic text-[clamp(3rem,8vw,8rem)] leading-none text-bone whitespace-nowrap">{w}</span>
          <span className="text-gold text-4xl">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <section className="py-20 md:py-28 border-y border-hair bg-ink-2 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {line}
        {line}
      </div>
    </section>
  );
}
